import { updateDraft } from './messageHelpers';

export default class extends Controller {
  static targets = [ 'nameField', 'idField', 'urlField'];

  saveAttachment(event) {
    event && event.preventDefault();
    this.removeReplacedLinkIfPresent();
    this.appendNewLinkAttachment();
    this.closeSlideOutAndUpdateDraft();
  }

  //
  // INTERNAL USE
  //

  appendNewLinkAttachment() {
    const listing = document.createElement('div');
    listing.innerHTML = this.parentForm.querySelector('.link-attachment-template').innerHTML
                          .replace(/\$LINK_NAME/g, this.linkName)
                          .replace(/\$LINK_URL/g, this.linkURL)
                          .replace(/\$INDEX/g, this.linkIndex)
                          .replace(/\$LINK_ID/g, this.linkID)
                          .trim();
    this.destination.appendChild(listing.firstChild);
  }

  removeReplacedLinkIfPresent() {
    this.linkEl && this.linkEl.remove();
  }

  closeSlideOutAndUpdateDraft() {
    App.SlideOut.close();
    updateDraft(this.parentForm, true);
  }

  //
  // GETTERS
  //

  get parentForm() {
    return document.querySelector(this.data.get('parent-form-selector'));
  }

  get parentFormID() {
    return this.parentForm.id;
  }

  get destination() {
    return this.parentForm.querySelector(this.data.get('destination-selector'));
  }

  get linkURL() {
    const url = this.urlFieldTarget.value;
    return (url.indexOf('http') === 0) ? url : `http://${url}`;
  }

  get linkName() {
    return this.nameFieldTarget.value;
  }

  get linkIndex() {
    return new Date().getTime();
  }

  get linkID() {
    return this.idFieldTarget.value;
  }

  get linkEl() {
    return this.data.has('link-element-id') && document.getElementById(this.data.get('link-element-id'));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/message-link-attachment-form-controller.js